import React from 'react';

import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const SalesConversionChart = ({ data = [], height = 300 }) => {
  const defaultData = [
    { stage: 'Leads', value: 1000, percentage: 100, color: '#2B7FFF' },
    { stage: 'Qualified', value: 600, percentage: 60, color: '#00C950' },
    { stage: 'Proposals', value: 300, percentage: 30, color: '#9810FA' },
    { stage: 'Negotiations', value: 150, percentage: 15, color: '#FF8C00' },
    { stage: 'Closed Won', value: 80, percentage: 8, color: '#E7000B' },
  ];

  const chartData = data.length > 0 ? data : defaultData;

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div
          style={{
            backgroundColor: 'white',
            padding: '12px',
            border: '1px solid #e0e0e0',
            borderRadius: '6px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            minWidth: '120px',
          }}
        >
          <p style={{ margin: '0 0 8px 0', fontWeight: '600', fontSize: '14px' }}>{label}</p>
          <p style={{ margin: '4px 0', fontSize: '13px', color: '#666' }}>
            Count: {data.value}
          </p>
          <p style={{ margin: '4px 0', fontSize: '13px', color: '#666' }}>
            Rate: {data.percentage}%
          </p>
        </div>
      );
    }
    return null;
  };

  const CustomBar = (props) => {
    const { fill, payload } = props;
    return <Bar {...props} fill={payload.color || fill} />;
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={chartData}
        layout="horizontal"
        margin={{
          top: 20,
          right: 30,
          left: 80,
          bottom: 20,
        }}
      >
        <XAxis
          type="number"
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 12, fill: '#666' }}
        />
        <YAxis
          type="category"
          dataKey="stage"
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 12, fill: '#666' }}
          width={70}
        />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="value" radius={[0, 4, 4, 0]} shape={<CustomBar />}>
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SalesConversionChart;
